export interface SearchAiLaunchRequest {
  requestId: string;
  query: string;
  action: 'newChatAndSearch';
  source: 'headerSearch';
}

/** 空输入只打开导购首页；非空输入携带一次性操作 ID，供子应用新建会话并自动检索。 */
export const buildSearchAiLaunchUrl = (origin: string, keyword: string, requestId: string): string => {
  const targetUrl = new URL('/rede/searchAi', origin);
  const query = keyword.trim();
  if (query) {
    targetUrl.searchParams.set('q', query);
    targetUrl.searchParams.set('requestId', requestId);
  }
  return targetUrl.toString();
};

/** 只有关键词和操作 ID 同时有效时才生成启动指令，避免创建空会话。 */
export const parseSearchAiLaunchRequest = (search: string): SearchAiLaunchRequest | null => {
  const params = new URLSearchParams(search);
  const query = params.get('q')?.trim();
  const requestId = params.get('requestId')?.trim();
  if (!query || !requestId) return null;
  return { requestId, query, action: 'newChatAndSearch', source: 'headerSearch' };
};
